import {env} from "./EnvironmentConfig";
import {CUSTOM_APP_NAME, NAV_TYPE} from "../constants/AuthConstant";
import {PRIMARY_BASE, SECONDARY_BASE} from "../constants/ThemeConstant";

export const APP_NAME = localStorage.getItem(CUSTOM_APP_NAME) || "Telecom Portal";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const AUTH_PREFIX_PATH = "/login";
export const SIGN_UP_PREFIX_PATH = "/sign-up";
export const REVIEW_SIGN_UP_PREFIX_PATH = "/review-sign-up";
export const FORGET_PASSWORD_PREFIX_PATH = "/forget-password";
export const RESET_PASSWORD_PREFIX_PATH = "/reset-password";
export const APPLICATION_LOGIN_PREFIX_PATH = "/app-login";
export const APP_PREFIX_PATH = "/backoffice";
export const RESELLER_PREFIX_PATH = "/reseller";
export const RESPONDER_PREFIX_PATH = "/responder";
export const ADVERTISER_PREFIX_PATH = "/advertiser";
export const CUSTOMER_PREFIX_PATH = "/customer";
export const REDIRECT_URL_KEY = "redirect";
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboard`;

export const THEME_CONFIG = {
    currentTheme: "light",
    navType: localStorage.getItem(NAV_TYPE) ? localStorage.getItem(NAV_TYPE) : "SIDE",
    sideNavTheme: "SIDE_NAV_LIGHT",
    navCollapsed: false,
    primaryColor: PRIMARY_BASE,
    secondaryColor: SECONDARY_BASE,
    topNavColor: PRIMARY_BASE,
    headerNavColor: localStorage.getItem(NAV_TYPE) !== "SIDE" ? SECONDARY_BASE : "#FFFFFF",
    locale: "en",
    direction: "ltr",
};
